import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useRouter } from "router";

import { useAnalytics } from "@/components/analytics/useAnalytics";
import { errorEntryType } from "@/core/api";
import { refresh, socialLogin } from "@/data/session";
import { router } from "@/views/router";
import { useCreateSession } from "@/views/Session/hooks";

import { useLinkProfileAfterInvitation } from "./useLinkProfileAfterInvitation";

interface Props {}

export const SessionAuth0: React.FunctionComponent<Props> = React.memo(() => {
  const { searchParams, matchParams, push } = useRouter<any, any>();
  const { login_token, error, invitation_id, invitation_token, jobRequestId, provider } = searchParams;
  const { pathName } = matchParams;
  const history = useHistory();

  const { createSession } = useCreateSession();
  const linkProfileAfterInvitation = useLinkProfileAfterInvitation();
  const { sendEvent } = useAnalytics();

  useEffect(() => {
    const asyncEffect = async () => {
      let linkingResult = true;

      try {
        await socialLogin({ token: login_token });
        const sessionUser = await refresh();

        sendEvent({ type: "login", method: provider });

        if (invitation_id && invitation_token) {
          linkingResult = await linkProfileAfterInvitation(invitation_id, invitation_token);
        }

        if (linkingResult) {
          await createSession(sessionUser);
        }
        if (jobRequestId && jobRequestId !== "undefined") {
          history.push(router.get("job-requests.detail", { jobRequestId }).path);
        } else {
          history.push(router.get("dashboard").path);
        }
      } catch (response) {
        const payload = errorEntryType(response.payload);

        push(router.get(pathName).path, { error: payload.value });
      }
    };

    if (login_token) {
      asyncEffect();
    } else if (error) {
      push(router.get(pathName).path, { error: error.replace(/\[.*?\]/g, "") });
    }
  }, [login_token]);
  return null;
});
